<p>collection-browse-bottom-sheet works!</p>
